/* eslint-env browser */
/* global gigya */

export function loadGigyaScript(apiKey) {
  return new Promise((resolve, reject) => {
    const scriptSrc = `https://cdns.gigya.com/js/gigya.js?apikey=${apiKey}`

    if (document.head.querySelector(`script[src="${scriptSrc}"]`)) {
      return resolve()
    }

    const script = document.createElement('script')
    script.src = scriptSrc
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Gigya script load failed'))
    document.head.appendChild(script)
  })
}

export function interceptNewsletterLinks(selector = 'a[href="#newsletter"]', apiKey = '') {
  const links = document.querySelectorAll(selector)

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()

      loadGigyaScript(apiKey)
        .then(() => {
          if (window.gigya?.accounts) {
            gigya.accounts.showScreenSet({
              screenSet: 'meinDFB-LiteRegistration',
            })
          } else {
            console.warn('Gigya accounts object missing.')
          }
        })
        .catch((err) => {
          console.error('Gigya script load error:', err)
        })
    })
  })
}
